import { makeStyles } from '@mui/styles';
import { CustomTheme } from 'types/theme';

export const useStyles = makeStyles((theme: CustomTheme) => ({
  captchaTerms: {
    textAlign: 'center',
    '&.MuiTypography-root': {
      color: theme.palette.text.secondary,
      fontSize: 12,
      lineHeight: '17px',
      letterSpacing: 0.20000000298023224,
      marginTop: 5
    }
  },
  link: {
    color: theme.palette.primary.main,
    fontWeight: 700,
    cursor: 'pointer',
    '&.MuiTypography-root': {
      textDecoration: 'none'
    }
  }
}));
